import React from 'react'
import { Col } from '../col'
interface IActionDetailsCondition {
  children: React.ReactNode
}

export const ActionDetailsCondition = (props: IActionDetailsCondition) => {
  const { children } = props

  return (
    <Col className='gap-xs fixed sm:relative  bottom-0 sm:bottom-auto left-0 sm:left-auto right-0 sm:right-auto bg-neutral-surface-light sm:bg-transparent p-md sm:p-0 rounded-t-sm sm:rounded-none border-t sm:border-t-0 border-neutral-surface-dark shadow-sm sm:shadow-none'>
      {children}
    </Col>
  )
}
